import React, {useContext, useEffect, useRef, useState} from 'react';
import {IonHeader, IonPage} from '@ionic/react';
import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from '../../components/content/content.style';
import {useTranslation} from 'react-i18next';
import WorkerWarehousePane from "./panes/workerWarehousePane.component";
import WorkerWarehouseScanPane from "./panes/workerWarehouseScanPane.component";
import SubNavigation, {
    SubNavigationOption,
    SubNavigationContext
} from "../../components/sub-navigation/subNavigation.component";

enum TabOptions {
    LIST = 0,
    SCAN = 1,
}

const WorkerWarehousePage: React.FC = () => {
    const {t} = useTranslation();
    const header = useRef<HTMLIonHeaderElement>(null);
    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);
    const [selectedOption, setSelectedOption] = useState<number>(TabOptions.LIST);
    const [refreshList, setRefreshList] = useState<number>(0);
    const subNavigationContext = useContext(SubNavigationContext);

    const options: SubNavigationOption[] = [
        {name: t("workerWarehousePage.tabs.list")},
        {name: t("workerWarehousePage.tabs.scan")},
    ];

    useEffect(() => {
        updateHeight();
    }, []);

    const updateHeight = () => {
        if (header.current?.clientHeight == 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const handleItemScanned = () => {
        setRefreshList(prev => prev + 1);
        setSelectedOption(TabOptions.LIST);
        subNavigationContext.setSelected(TabOptions.LIST);
    };

    const handleSelect = (option: SubNavigationOption) => {
        const optionIndex = options.indexOf(option);
        setSelectedOption(optionIndex);
    };

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <StyledIonTitle className="left">{t("workerWarehousePage.title")}</StyledIonTitle>
                    </StyledIonToolbar>
                    <SubNavigation options={options} defaultValue={selectedOption} onSelect={handleSelect}/>
                </IonHeader>
                {selectedOption === TabOptions.LIST && <WorkerWarehousePane topEdge={topEdge} key={refreshList}/>}
                {selectedOption === TabOptions.SCAN &&
                    <WorkerWarehouseScanPane topEdge={topEdge} onItemScanned={handleItemScanned}/>}
            </StyledIonContent>
        </IonPage>
    );
};

export default WorkerWarehousePage;
